/**
 * EntityName
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityTypeName from '../EntityTypeName';

// Selectors
import { makeSelectEntityValue } from '../../services/entities/selectors';

export class EntityName extends React.PureComponent {
    render() {
        const { entityTypeId, name, hideEntityType, hideBrackets } = this.props;

        return (
            <React.Fragment>
                {name}{' '}
                {!hideEntityType && entityTypeId && (
                    <React.Fragment>
                        {!hideBrackets && '('}
                        <EntityTypeName entityTypeId={entityTypeId} />
                        {!hideBrackets && ')'}
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

EntityName.propTypes = {
    entityTypeId: PropTypes.number,
    name: PropTypes.string,
    hideEntityType: PropTypes.bool
};

EntityName.defaultProps = {
    entityTypeId: null,
    name: null,
    hideEntityType: false
};

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectEntityValue('entityTypeId'),
    name: makeSelectEntityValue('name')
});

export default connect(mapStateToProps)(EntityName);
